import { produce } from "immer";
import { Store } from "reducers/rootReducer";

type State = {
  parentProgrammeID: number | null;
};

const initialState: State = {
  parentProgrammeID: null,
};

const SET_PARENT_PROGRAMME_ID = "app/customFields/SET_PARENT_PROGRAMME_ID";
const RESET_PARENT_PROGRAMME_ID = "app/customFields/RESET_PARENT_PROGRAMME_ID";

type Action =
  | {
      type: typeof SET_PARENT_PROGRAMME_ID;
      payload: number;
    }
  | {
      type: typeof RESET_PARENT_PROGRAMME_ID;
    };

export default function reducer(state = initialState, action: Action): State {
  return produce(state, draft => {
    switch (action.type) {
      case SET_PARENT_PROGRAMME_ID:
        draft.parentProgrammeID = action.payload;
        break;
      case RESET_PARENT_PROGRAMME_ID:
        draft.parentProgrammeID = null;
    }
  });
}

export const setParentProgrammeId = (payload: number): Action => ({
  type: SET_PARENT_PROGRAMME_ID,
  payload: payload,
});

export const resetParentProgrammeId = (): Action => ({
  type: RESET_PARENT_PROGRAMME_ID,
});

export const selectParentPorgrammeId = (app: Store) =>
  app.customFields.parentProgrammeID;
